<template>
    <v-card v-ripple="false">
        <div :class="class_list" class="games-card">
            <div class="bid-list" :class="item_game">
                <v-list color="transparent" class="pa-0" v-if="matches.user && game.type == 1 || matches.user && game.type == 3 && matches.max_players == 2">
                    <v-list-item class="pa-0">
                        <div class="block-img" :class="(matches.user.pro) ? 'user-pro-img' : ''">
                            <router-link :to="{name: 'profile', params: {id: matches.user.public_id, lang: $store.getters.getLang}}" >
                                <div class="wrap-img ">
                                    <!--                <img :src="'/assets/users/'+((matches.user.photo) ? matches.user.photo : 'a-default.svg')"/>-->
                                    <img v-if="matches.user.photo && typeof matches.user.photo == 'object'" :src="matches.user.photo[40]"/>
                                    <img v-else-if="matches.user.photo" :src="matches.user.photo"/>
                                    <span v-else class="photo" :style="{'background': matches.user.bg_color}">{{matches.user.name.substr(0,1)}}</span>
                                </div>
                                <div class="online"></div>
                            </router-link>
                        </div>
                        <v-list-item-content class="person-info pa-0">
                            <v-list-item-title>
                                <router-link :class="(matches.user.pro) ? 'user-pro' : ''" :to="{name: 'profile', params: {id: matches.user.public_id, lang: $store.getters.getLang}}" >
                                    {{matches.user.name+" "+((matches.user.last_name) ? matches.user.last_name : '')}}
                                </router-link>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                <div class="block-raiting">
                                    <img class="ml-0 mr-1" height="12px" src="/dist/images/frontend/fire.svg" alt />
                                    <span style="color: #F6A401">{{matches.user.rating_points}}</span>
                                </div>
                                <span style="color: #96AFD1">
                                    <img width="14" :src="matches.user.location_img" />
                                    {{$getLocation(matches.user.location)}}
                                    </span>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-list color="transparent" class="pa-0" v-else-if="(game.type == 2 || game.type == 3 || game.type == 4) && matches.max_players == 2">
                    <v-list-item class="pa-0">
                        <div class="block-img-game">
                            <router-link :to="{name: 'game', params: {id: game.url, lang: $store.getters.getLang}}">
                                <div class="wrap-img-game" v-if="matches.user">
                                  <img v-if="matches.user.photo && typeof matches.user.photo == 'object'" :src="matches.user.photo[40]"/>
                                  <img v-else-if="matches.user.photo" :src="matches.user.photo"/>
                                  <span v-else class="photo" :style="{'background': matches.user.bg_color}">{{matches.user.name.substr(0,1)}}</span>
                                </div>
                                <div class="wrap-img-game" v-else>
                                  <img v-if="typeof game.logo == 'object'" :src="game.logo[100]">
                                  <img v-else :src="game.logo">
                                </div>
                            </router-link>
                        </div>
                        <v-list-item-content class="person-info pa-0">
                            <v-list-item-title>
                              <span>{{matches.name}}</span>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                <div class="block-info-game">
                                    <div class="block-info-game__players">
                                        <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.42566 2.80248C9.42566 4.17313 8.33297 5.27217 6.97024 5.27217C5.60752 5.27217 4.51483 4.17313 4.51483 2.80248C4.51483 1.4313 5.60752 0.333313 6.97024 0.333313C8.33297 0.333313 9.42566 1.4313 9.42566 2.80248ZM6.97025 9.66665C4.96873 9.66665 3.2597 9.34934 3.2597 8.08008C3.2597 6.8103 4.95776 6.48143 6.97025 6.48143C8.97178 6.48143 10.6808 6.79874 10.6808 8.06852C10.6808 9.33778 8.98275 9.66665 6.97025 9.66665ZM10.475 2.84704C10.475 3.54576 10.2665 4.19667 9.90092 4.73779C9.86332 4.79347 9.89675 4.8686 9.96308 4.88016C10.0545 4.89592 10.149 4.90485 10.2451 4.90747C11.2036 4.93269 12.0638 4.31225 12.3015 3.37817C12.6535 1.99071 11.6199 0.745095 10.3036 0.745095C10.1605 0.745095 10.0237 0.760331 9.89048 0.787649C9.8722 0.791852 9.85287 0.800258 9.84242 0.816544C9.82989 0.836507 9.83929 0.8633 9.85183 0.880637C10.2472 1.43804 10.475 2.11785 10.475 2.84704ZM12.0623 5.88232C12.7063 6.00893 13.1299 6.26741 13.3054 6.64304C13.4537 6.95142 13.4537 7.30918 13.3054 7.61704C13.0369 8.19966 12.1714 8.38668 11.8351 8.43502C11.7656 8.44552 11.7097 8.38511 11.717 8.31524C11.8889 6.70082 10.522 5.93538 10.1683 5.75939C10.1532 5.75151 10.1501 5.73943 10.1516 5.73207C10.1527 5.72682 10.1589 5.71841 10.1704 5.71684C10.9356 5.70265 11.7583 5.80772 12.0623 5.88232ZM3.75495 4.90741C3.85106 4.90478 3.94508 4.89638 4.037 4.88009C4.10334 4.86853 4.13677 4.79341 4.09916 4.73772C3.73354 4.19661 3.52513 3.54569 3.52513 2.84697C3.52513 2.11778 3.75286 1.43797 4.14826 0.880572C4.16079 0.863235 4.16967 0.836442 4.15766 0.816479C4.14721 0.800718 4.12736 0.791787 4.10961 0.787584C3.97589 0.760266 3.83904 0.745031 3.69593 0.745031C2.37969 0.745031 1.34602 1.99064 1.69858 3.3781C1.93624 4.31218 2.7965 4.93263 3.75495 4.90741ZM3.84819 5.73175C3.84976 5.73963 3.84663 5.75119 3.832 5.7596C3.47787 5.93559 2.11096 6.70103 2.28281 8.31492C2.29012 8.38532 2.23475 8.44521 2.16528 8.43523C1.82891 8.38689 0.96343 8.19987 0.694959 7.61725C0.546098 7.30887 0.546098 6.95163 0.694959 6.64324C0.870457 6.26762 1.29354 6.00914 1.93755 5.88201C2.24207 5.80793 3.06419 5.70286 3.82991 5.71704C3.8414 5.71862 3.84715 5.72703 3.84819 5.73175Z" fill="#6886AF"/>
                                        </svg>
                                        <span>{{matches.user_play}}</span>/{{matches.max_players}}
                                    </div>
<!--                                    <span class="circle"></span>-->
<!--                                    <p class="game-info-game__created">-->
<!--                                        {{__('Created by')}}-->
<!--                                        <router-link v-if="game.developer.id == matches.user_id" :to="{name: 'profile', params: {id: matches.user.public_id, lang: $store.getters.getLang}}" >-->
<!--                                            {{__('Admin')}}-->
<!--                                        </router-link>-->
<!--                                        <router-link v-else :to="{name: 'profile', params: {id: matches.user.public_id, lang: $store.getters.getLang}}" >-->
<!--                                            {{__('User')}}-->
<!--                                        </router-link>-->
<!--                                    </p>-->
                                </div>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>


                <v-list color="transparent" v-else class="pa-0">
                    <v-list-item class="pa-0">
                        <div class="block-img-game">
                            <router-link :to="{name: 'game', params: {id: game.url, lang: $store.getters.getLang}}">
                                <div class="wrap-img-game">
                                    <img v-if="typeof game.logo == 'object'" :src="game.logo[100]">
                                    <img v-else :src="game.logo">
                                </div>
                            </router-link>
                        </div>
                        <v-list-item-content class="person-info pa-0">
                            <v-list-item-title>
                                <router-link :to="{name: 'game', params: {id: game.url, lang: $store.getters.getLang}}">
                                    {{game_array.name}}
                                </router-link>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                <!--              <div class="d-flex rating">-->
                                <!--                <div class="d-flex">-->
                                <!--                  <span>{{game.rating}}</span>-->
                                <!--                  <v-rating-->
                                <!--                    v-model="game.rating"-->
                                <!--                    background-color="grey darken-1"-->
                                <!--                    color="blue lighten-1"-->
                                <!--                    readonly-->
                                <!--                    dense-->
                                <!--                    size="18"-->
                                <!--                    class="mr-2"-->
                                <!--                  ></v-rating>-->
                                <!--                </div>-->
                                <!--&lt;!&ndash;                <router-link :to="{name: 'profile', params: {id: game.developer.id}}">&ndash;&gt;-->
                                <!--&lt;!&ndash;                  {{game.developer.name+" "+((game.developer.last_name) ? game.developer.last_name : '')}}&ndash;&gt;-->
                                <!--&lt;!&ndash;                </router-link>&ndash;&gt;-->
                                <!--              </div>-->
                                <div v-if="game.type == 2 && game.type== 3 || game.type == 4 && matches.max_players > 2" class="block-info-game">
                                    <div class="block-info-game__players">
                                        <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.42566 2.80248C9.42566 4.17313 8.33297 5.27217 6.97024 5.27217C5.60752 5.27217 4.51483 4.17313 4.51483 2.80248C4.51483 1.4313 5.60752 0.333313 6.97024 0.333313C8.33297 0.333313 9.42566 1.4313 9.42566 2.80248ZM6.97025 9.66665C4.96873 9.66665 3.2597 9.34934 3.2597 8.08008C3.2597 6.8103 4.95776 6.48143 6.97025 6.48143C8.97178 6.48143 10.6808 6.79874 10.6808 8.06852C10.6808 9.33778 8.98275 9.66665 6.97025 9.66665ZM10.475 2.84704C10.475 3.54576 10.2665 4.19667 9.90092 4.73779C9.86332 4.79347 9.89675 4.8686 9.96308 4.88016C10.0545 4.89592 10.149 4.90485 10.2451 4.90747C11.2036 4.93269 12.0638 4.31225 12.3015 3.37817C12.6535 1.99071 11.6199 0.745095 10.3036 0.745095C10.1605 0.745095 10.0237 0.760331 9.89048 0.787649C9.8722 0.791852 9.85287 0.800258 9.84242 0.816544C9.82989 0.836507 9.83929 0.8633 9.85183 0.880637C10.2472 1.43804 10.475 2.11785 10.475 2.84704ZM12.0623 5.88232C12.7063 6.00893 13.1299 6.26741 13.3054 6.64304C13.4537 6.95142 13.4537 7.30918 13.3054 7.61704C13.0369 8.19966 12.1714 8.38668 11.8351 8.43502C11.7656 8.44552 11.7097 8.38511 11.717 8.31524C11.8889 6.70082 10.522 5.93538 10.1683 5.75939C10.1532 5.75151 10.1501 5.73943 10.1516 5.73207C10.1527 5.72682 10.1589 5.71841 10.1704 5.71684C10.9356 5.70265 11.7583 5.80772 12.0623 5.88232ZM3.75495 4.90741C3.85106 4.90478 3.94508 4.89638 4.037 4.88009C4.10334 4.86853 4.13677 4.79341 4.09916 4.73772C3.73354 4.19661 3.52513 3.54569 3.52513 2.84697C3.52513 2.11778 3.75286 1.43797 4.14826 0.880572C4.16079 0.863235 4.16967 0.836442 4.15766 0.816479C4.14721 0.800718 4.12736 0.791787 4.10961 0.787584C3.97589 0.760266 3.83904 0.745031 3.69593 0.745031C2.37969 0.745031 1.34602 1.99064 1.69858 3.3781C1.93624 4.31218 2.7965 4.93263 3.75495 4.90741ZM3.84819 5.73175C3.84976 5.73963 3.84663 5.75119 3.832 5.7596C3.47787 5.93559 2.11096 6.70103 2.28281 8.31492C2.29012 8.38532 2.23475 8.44521 2.16528 8.43523C1.82891 8.38689 0.96343 8.19987 0.694959 7.61725C0.546098 7.30887 0.546098 6.95163 0.694959 6.64324C0.870457 6.26762 1.29354 6.00914 1.93755 5.88201C2.24207 5.80793 3.06419 5.70286 3.82991 5.71704C3.8414 5.71862 3.84715 5.72703 3.84819 5.73175Z" fill="#6886AF"/>
                                        </svg>
                                        <span>{{matches.user_play}}</span>/{{matches.max_players}}
                                    </div>
<!--                                    <span class="circle"></span>-->
<!--                                    <p class="game-info-game__created">{{__('Multiplayer')}}</p>-->
                                </div>
                                <div v-else class="block-info-game">
                                    <div class="block-info-game__players">
                                        <svg width="12" height="10" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11.8182 2.00001V0.181824H10L6.50909 4.07273L7.85455 5.56364L11.8182 2.00001Z" fill="#6886AF"/>
                                            <path d="M0.181824 10.9091C0.181824 11.4182 0.581824 11.8182 1.09091 11.8182C1.67273 11.8182 2.1091 11.2728 1.96364 10.7273L3.78182 8.90912L5.23637 10.3637V9.27276L4.5091 8.54549L5.41819 7.74548L4.14546 6.58185L3.38182 7.41821L2.65455 6.69094H1.56364L3.01819 8.14548L1.20001 9.96367C0.690915 9.89094 0.181824 10.3273 0.181824 10.9091Z" fill="#6886AF"/>
                                            <path d="M6.72728 9.27273V10.3636L8.18182 8.9091L10 10.7273C9.89091 11.3091 10.3273 11.8182 10.8727 11.8182C11.3818 11.8182 11.7818 11.4182 11.7818 10.9091C11.7818 10.3636 11.2727 9.92728 10.6909 10L8.87273 8.18182L10.3273 6.72728H9.23637L8.5091 7.41819L2.00001 0.181824H0.181824V2.00001L7.45455 8.58182L6.72728 9.27273Z" fill="#6886AF"/>
                                        </svg>
                                        <p class="game-info-game__created">{{__('Battle 1 vs 1')}}</p>
                                    </div>
                                </div>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                <!--        <pre>{{matches}}</pre> <br>-->
                <!--        <pre>{{this.game}} </pre>-->
                <div class="wrapper-attributes" v-if="matches.attributes && matches.attributes.length">
                    <GameAttributesItem v-for="(attributes, key) in sortAttributes" :key="key" v-bind:attribute="attributes"></GameAttributesItem>
                </div>
                <!--      <div class="money">{{matches.amount}} {{(matches.wallet== 1) ? 'real' : 'lite'}}</div>-->

                <div class="block-right">
                    <div class="block-money" v-if="game.type == 2 || game.type== 3 || game.type == 4">
                        <div class="wrap-icon">
                            <img v-if="(matches.wallet== 1)" class="pic" src="/dist/images/frontend/money.svg" alt/>
                            <img v-else class="pic" src="/dist/images/frontend/light-coin.svg" alt />
                        </div>

                        <span v-if="(matches.wallet== 1)" class="warning--text">{{formatNumber(primNum(matches.amount, 2))}}</span>
<!--                        <span v-else class="block-money__lite">{{primNum(matches.amount, 2)}}</span>-->
                        <span v-else class="block-money__lite">{{formatNumber(primNum(matches.amount, 2))}}</span>
                    </div>

                    <div class="block-money" v-else>
                        <div class="wrap-icon">
                            <img v-if="(matches.wallet== 1)" class="pic" src="/dist/images/frontend/money.svg" alt/>
                            <img v-else class="pic" src="/dist/images/frontend/light-coin.svg" alt />
                        </div>

                        <span v-if="(matches.wallet== 1)" class="warning--text">
                          <p>{{formatNumber(primNum(matches.amount_from, 2))}}</p>
                           <span class="line">-</span>
                         <p>{{formatNumber(primNum(matches.amount_to, 2))}}</p>
                      </span>
                        <span v-else class="block-money__lite">
                          <p>{{formatNumber(primNum(matches.amount_from, 2))}}</p>
                           <span class="line">-</span>
                         <p>{{formatNumber(primNum(matches.amount_to, 2))}}</p>
                      </span>
                    </div>

                    <div class="wrap-btn">
                        <v-tooltip
                                v-if="game.type == 1"
                                v-model="show1"
                                bottom
                                color="transparent"
                                nudge-top="5"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <BaseButton v-on="on" v-bind="attrs" :width="65" @click="(submitDisabled) ? '' : editBid()">
                                    <span>
                                        <svg class="ma-0" v-if="matches.password" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_1999_843)">
                                                <path d="M18.828 1.17211C18.0722 0.41625 17.0673 0 15.9984 0C14.9296 0 13.9246 0.41625 13.1688 1.17207L1.98538 12.3555C1.89023 12.4507 1.82128 12.5688 1.78519 12.6984L0.0286229 19.0093C-0.0471193 19.2814 0.029951 19.5734 0.230303 19.7726C0.37874 19.9203 0.577647 20 0.781318 20C0.85249 20 0.924287 19.9902 0.994717 19.9702L7.30554 18.1776C7.57179 18.102 7.7782 17.8911 7.84804 17.6232C7.91788 17.3554 7.84077 17.0706 7.64535 16.8745L3.66675 12.8839L12.9369 3.61371L16.3845 7.06129L9.28781 14.1386C8.9823 14.4433 8.98163 14.9379 9.28632 15.2434C9.59097 15.549 10.0857 15.5496 10.3912 15.245L18.8279 6.83121C19.5838 6.07539 20 5.07051 20 4.00164C20 2.93277 19.5838 1.92789 18.828 1.17211ZM5.60136 17.0374L1.9073 18.0867L2.94187 14.3698L5.60136 17.0374ZM17.7239 5.72559L17.4909 5.95797L14.0418 2.50887L14.2737 2.27691C14.7344 1.81621 15.3469 1.5625 15.9984 1.5625C16.65 1.5625 17.2624 1.81621 17.7231 2.27695C18.1838 2.73762 18.4375 3.35012 18.4375 4.00164C18.4375 4.65316 18.1838 5.26566 17.7239 5.72559Z" fill="white"/>
                                                <path d="M15.3933 12.9547V13.364H13.6068V12.5457V12.4547C13.6068 12.0384 13.698 11.7695 13.8228 11.6136C13.932 11.477 14.1171 11.3637 14.4773 11.3637C14.8374 11.3637 15.0225 11.477 15.1318 11.6136C15.2566 11.7695 15.3478 12.0384 15.3478 12.4547V12.9547H15.3933ZM18.0835 13.3206V12.5001V12.4091C18.0835 10.2732 16.5817 8.5 14.477 8.5C12.3682 8.5 10.8705 10.3231 10.8705 12.4091V12.5001V13.3239C10.1027 13.3895 9.5 14.0336 9.5 14.8183V19C9.5 19.8284 10.1716 20.5 11 20.5H17.9997C18.8281 20.5 19.4997 19.8285 19.4997 19.0001L19.5 14.8184C19.5 14.018 18.8731 13.364 18.0835 13.3206Z" fill="white" stroke="#00AEFF"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_1999_843">
                                                    <rect width="20" height="20" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>

                                        <img class="ma-0" v-else src="/dist/images/frontend/icon-edit.svg" alt />
                                    </span>
                                </BaseButton>
                            </template>
                            <p class="block-name ma-0">
                                {{__('Edit match')}}
                            </p>
                        </v-tooltip>

                        <BaseButton :width="65" v-else-if="matches.max_players > 2"   @click="playGame()">
                            <img src="/dist/images/frontend/create-btn.svg" alt="/" />
                        </BaseButton>

                        <div style="margin-left: 10px" class="wrap-delete-btn">
                            <v-tooltip
                                    v-model="show2"
                                    bottom
                                    color="transparent"
                                    nudge-top="5"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <BaseButton
                                            v-on="on" v-bind="attrs"
                                            :width="65"
                                            :loading="submitDisabled"
                                            class_btn="btn-liteGrey"
                                            @click="cancelBid()"
                                    >
                              <span>
                                <img class="ma-0" src="/dist/images/frontend/icon-cancel.svg" alt />
                              </span>
                                    </BaseButton>
                                </template>
                                <p class="block-name ma-0">
                                    {{__('Delete match')}}
                                </p>
                            </v-tooltip>


                        </div>

<!--                        <v-btn-->
<!--                                v-if="matches.attributes && matches.attributes.length"-->
<!--                                @click="show = !show"-->
<!--                                class="btn-link"-->
<!--                                icon-->
<!--                                v-ripple="false"-->
<!--                        >-->
<!--                            <svg v-if="!show" width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                                <path d="M12.8334 1.08331L7.00008 6.91665L1.16675 1.08331" stroke="#96AFD1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--                            </svg>-->

<!--                            <svg v-else width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                                <path d="M1.16658 6.91669L6.99992 1.08335L12.8333 6.91669" stroke="#26A9F4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--                            </svg>-->
<!--                        </v-btn>-->
                    </div>
                </div>
            </div>
        </div>
        <v-expand-transition >
            <div v-show="show">
                <v-card-text>
                    <div class="wrapper-attributes-bottom" v-if="matches.attributes && matches.attributes.length">
                      <GameAttributesItem v-for="(attributes, key) in sortAttributes" :key="key" v-bind:attribute="attributes"></GameAttributesItem>
                    </div>
                </v-card-text>
            </div>
        </v-expand-transition>
    </v-card>
</template>

<script>

import GameAttributesItem from '../pages/Games/GameAttributesItem'
import _ from 'lodash';

export default {
  name: "GameBidList",
  data: function () {
    return {
      show: true,
      show1: false,
      show2: false,
      id: this.game.id,
      dialog: false,
      submitDisabled: false,
      edit_bid: null
    };
  },
  props: {
    game: {
      type: Object,
    },
    create_match_modal: {
      type: Object,
    },
    matches: {
      type: Object,
    },
    item_game: {
      type: String,
    },
    class_list: {
      type: String,
    },
  },
  computed: {
    auth() {
      return this.$store.state.auth.user;
    },
    lang() {
      return this.$store.state.language.lang;
    },
    // game_array() {
    //     return _.filter(this.game.game_translations ? this.game.game_translations : this.game.game_translations_all, {lang: this.lang});
    // },
      game_array() {
          if (this.$filterArray(this.game.game_translations ? this.game.game_translations : this.game.game_translations_all, this.lang, 'lang')) {
              return this.$filterArray(this.game.game_translations ? this.game.game_translations : this.game.game_translations_all, this.lang, 'lang');
          } else {
              return this.$filterArray(this.game.game_translations ? this.game.game_translations : this.game.game_translations_all, 'en', 'lang');
          }
      },
    sortAttributes() {
        let gameAttr= this.$cleanObject(this.game.attributes);
        let attributes= this.$cleanObject(this.matches.attributes);
        let options= [];
        _.forEach(gameAttr, function (value) {
            let attr= _.find(attributes, {key: value.key});
            let option;
            if(attr) {
                option= _.find(value.options, {key: attr.option});
                option.attrName = value.name;
                if(option) {
                    options.push(option);
                }
            }
        });
        return options;
        // let attributes,
        //     option;

        // for (let i = 0; i < this.game.attributes.length; i++) {
        //     if (item.key == this.game.attributes[i].key) {
        //         attributes = this.game.attributes[i];
        //         break;
        //     }
        // }
        //
        // attributes= _.filter(game,{key: item.key})[0];
        //
        // console.log('item');
        // console.log(JSON.stringify(game));
        // console.log(JSON.stringify(item));
        // console.log('attributes');
        // console.log(JSON.stringify(attributes));
        // for (let i = 0; i < attributes.options.length; i++) {
        //
        //     if (item.option == attributes.options[i].key) {
        //         option = attributes.options[i];
        //
        //         break;
        //     }
        // }
        // return {attributes, option};
    },
  },
  methods: {
    cancelBid() {
      let matches = this.matches;
      this.submitDisabled= true;

      const formData = {
        match_id: matches.id,
        game_id: this.game.id,
        operation: "remove",
      };
        this.$http.post("ajax/games/" + this.game.id + "/remove_match", formData)
            .then((response) => {
                return response.json();
            })
            .then((response) => {
                if(this.$checkAuth(response)) {
                    this.submitDisabled = false;

                    this.$emit('removeListGame', matches.id);
                }
            })
            .catch((err) => {
                this.httpHandler(err);
                this.submitDisabled= false;
            });
    },
    editBid() {
      this.$emit("update:create_match_modal", this.game);
      this.$emit("update:edit_bid", this.matches);
    },
    updateModal() {
        this.$emit("update:create_match_modal", null);
        this.$emit("update:edit_bid", null);
    },
    playGame() {
      let matches = this.matches;
      // this.submitDisabled = true;

      const formData = {
          game_id: matches.game_id,
          match_id: matches.id,
          user_id: matches.user_id

      };
        this.$http.post('ajax/games/play_on', formData)
          .then((response) => {
              return response.json();
          })
          .then((response) => {
              if(this.$checkAuth(response)) {
                if (response.data.success === true && response.data.room_id) {
                    this.$router.push({
                        name: "frame",
                        params: {
                            id: this.game.url,
                            room_id: response.data.room_id,
                            battle_id: response.data.battle_id,
                            lang: this.$store.getters.getLang,
                        },
                    });
                    this.$store.dispatch("asyncInviteGame", []);
                }
              }
          })
          .catch((err) => {
              this.httpHandler(err);
          });
    }
  },
  mounted() {
  },
  components: {
      GameAttributesItem
  },
};
</script>

<style lang="scss" scoped>

    .dark .theme--light.v-card {
        background: #171827!important;
    }

    .dark .theme--light.v-sheet {
        border-color: #171827!important;
    }

    .dark .item_game {
        background: #171827!important;
    }

    .dark .bid-list {
        background: transparent;

        .v-list-item {
            &__title {
                color: #fff;
                a {
                    color: #fff;
                }
            }

            &__subtitle {
                .block-info-game {
                    .circle {
                        background-color: #96AFD1;
                    }
                }
            }
        }
    }

    .dark .v-sheet.v-card {
        border-radius: 0;
        border-bottom: 1px solid #2B2B2B!important;
    }

    .v-sheet.v-card:not(.v-sheet--outlined) {
        box-shadow: none;
    }

    .v-sheet.v-card {
        border-radius: 0;
        border-bottom: 1px solid #ECF4FF;
    }

    .v-card__text {
        padding: 0;
    }


.dark {
    .online {
        border: 2px solid #171827;
    }
}
.online {
  border: 2px solid #fff;
  border-radius: 50%;
  background-color: #00C569;
  width: 10px;
  height: 10px;
  position: absolute;
  right: 0;
  bottom: 2px;
}

.bid-list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 12px 5px 5px;
  background: linear-gradient(90deg, #FFFFFF 0%, rgba(255, 255, 255, 0.9) 38.42%, rgba(255, 255, 255, 0.5) 99.34%);
  border-radius: 8px;
  margin-bottom: 10px;

  .v-list-item {

    &__content {
      display: block;
    }

    &__title {
      display: block;
      font-weight: 400;
      font-size: 14px;
      line-height: 19px;
      text-transform: capitalize;
      color: #002B50;
      margin-bottom:3px;
      cursor: pointer;
      max-width: 170px;
      min-width: 170px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

        a {
            color: #002B50;
            text-decoration: none;

            &:hover {
                text-decoration: underline;
                color: #4EBEFF;
            }
        }
    }

    &__subtitle {
      font-size: 12px;
      line-height: 16px;
      max-width: 170px;
      min-width: 170px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: flex;
      align-items: center;

        .block-raiting {
            margin-right: 10px;
            img {
                margin-bottom: 3px;
            }
        }

        .block-info-game {
            display: flex;
            align-items: center;
            font-weight: 400;
            font-size: 13px;
            line-height: 18px;
            color: #6886AF;

            &__players {
                margin-right: 7px;
                display: flex;
                align-items: center;
                svg {
                    margin-right: 4px;
                }
                
                span {
                    color: #26A9F4;
                    font-weight: bold;
                }
            }

            p {
                margin: 0;

                span {
                    color: #26A9F4;
                    margin-left: 1px;
                }
            }

            .circle {
                display: block;
                min-width: 5px;
                min-height: 5px;
                border-radius: 50%;
                background-color: #CBDAE9;
                margin-right: 7px;
            }

            &__created {
                margin: 0;
            }

            a {
                color: #26A9F4;
                text-decoration: none;
                transition-duration: .3s;

                &:hover {
                    text-decoration: underline;
                    transition-duration: .3s;
                }
            }
        }
    }
  }
}
.games-card {
  /*border-bottom: 1px solid #ECF4FF;*/
}

.list-profile {
  /*border-bottom: 2px solid #ECF4FF;*/
  /*margin-left: 0;*/
  //margin-right: 7px;

  .bid-list {
    padding: 10px 10px 10px 10px;
    margin-bottom: 0;
  }
}
.item_game {
    border-radius: 8px;
    background-color: #fff;
    margin-bottom: 0;
    padding: 6px 20px 6px 20px;

    &:last-child {
      border-radius: 8px;
    }
}

.block-img {
  margin-right: 10px;
  position: relative;

  a {
    text-decoration: none;
  }

  .wrap-img {
    width: 40px;
    height: 40px;
    border-radius: 50%;

    img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
    }
  }
  .photo {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    color: #FFFFFF;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    font-size: 20px;
    font-weight: bold;
    text-transform: uppercase;
    text-decoration: none;
  }
}

.block-img-game {
  margin-right: 10px;
  position: relative;

  .wrap-img-game {
    width: 54px;
    height: 54px;
    border-radius: 8px;
    box-shadow: 0px 2px 24px rgba(0, 0, 0, 0.05);

    img {
      width: 54px;
      height: 54px;
      border-radius: 8px;
    }
  }
}

.rating {
  span {
    margin-right: 6px;
    margin-top: 3px;
    /*font-weight: bold;*/
    font-size: 14px;
    line-height: 22px;
    letter-spacing: -0.408px;
    color: #96afd1;
  }

  .v-rating {
    margin-top: 2px;

    .v-rating--dense .v-icon {
      padding: 0;
    }
  }

  a {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #26a9f4;
    text-decoration: none;
    margin-top: 7px;

    &:hover {
      text-decoration: underline;
    }
  }
}

.wrapper-attributes {
    margin: 0 0 0 44px;
    width: 100%;
    /*min-height: 36px;*/
    height: 100%;
    display: flex;
    align-content: space-between;
    flex-wrap: wrap;
}

.dark {
    .wrapper-attributes-bottom {
        background: #171827;
        border-bottom: 1px solid #363636;
    }
}

.wrapper-attributes-bottom {
    display: none;
    align-content: space-between;
    flex-wrap: wrap;
    overflow: hidden;
    background-color: #F3F7FE;
    border-bottom: 1px solid #ECF4FF;
    margin: 0 -1px;
}

.money {
  font-size: 14px;
}

/*.btn-edit {*/
/*  text-transform: inherit;*/
/*  outline: none;*/
/*  border-radius: 8px;*/
/*  background-color: #00C443;*/
/*  margin-right: 10px;*/
/*    &:hover {*/

/*      background-color: #00ad3b;*/
/*    }*/
/*}*/

.v-btn.btn-edit {
    &.v-btn:not(.v-btn--round).v-size--default {
        height: 40px;
        min-width: 65px;
        margin-right: 10px;
        padding: 10px;
    }
}

.cancel {
  text-transform: inherit;
  border-radius: 6px;
  background: #F0F6FE;
  margin-left: 10px;
  outline: none;
  &:hover {
    background-color: #E7EFFF;
  }
}

.v-btn:not(.v-btn--round).v-size--default {
  height: 40px;
  min-width: 65px;
  // width: 124px;
  padding: 10px;
}

.block-right {
    display: flex;
    align-items: center;
    white-space: nowrap;
}

    .dark .block-money {
        &__lite {
            color: #96AFD1;
        }
    }

.block-money {
  display: flex;
  align-items: center;

    &__lite {
        color: #6886af;
    }

    .wrap-icon {
        width: 58px;
        display: flex;
        justify-content: center;

        img {
            height: 18px;
        }
    }

    span {
        display: flex;
        width: 160px;
        justify-content: center;
        align-items: center;

        .line {
            width: fit-content;
            margin: 0 5px;
        }

        p {
            margin: 0;
            width: 70px;
            text-align: center;
        }
    }


}

.wrap-btn {
    display: flex;
    align-items: center;
    width: 170px;
    justify-content: flex-end;

    .v-btn.btn-link {
        /*margin-left: 10px;*/
        display: none;
        position: absolute;
        z-index: 10;
        bottom: -5px;
        left: calc(50% - 18px);
        height: 24px;
    }
}

    .block-name {
        display: block;
        text-align: center;
        text-overflow: ellipsis;
        z-index: 1;
        font-size: 13px;
        line-height: 18px;
        color: #002B50;
        padding: 4px 8px;
        background: rgb(255, 255, 255);
        border: 1px solid #ECF4FF;
        border-radius: 6px;
        width: 100px;
        overflow: hidden;
        white-space: nowrap;
    }

@media screen and (max-width: 1600px) {
  .wrapper-attributes {
    margin: 0;
  }
}

@media screen and (max-width: 1200px) {
    .block-money {

        .wrap-icon {
            width: 40px;
        }
    }

    .wrap-btn {
        width: 150px;
    }
}

@media screen and (max-width: 1100px) {
    .item_game {
        padding: 6px 10px 6px 10px;
    }

    .wrapper-attributes {
        display: none;
    }
    .wrapper-attributes-bottom {
        display: flex;
        padding: 6px 12px;
    }

    .wrap-btn {
        width: fit-content;
        margin-left: 10px;

        .v-btn.btn-link {
            display: block;
        }
    }
}

@media screen and (max-width: 800px) {

  .bid-list {
    .v-list-item {
      &__title {
        font-weight: 400;
        font-size: 14px;
        line-height: 19px;
        text-transform: capitalize;
        color: #002B50;
        margin-bottom:3px;
      }
    }
  }

  .online {
    right: 4px;
    bottom: 0px;
  }

  /*.block-img {*/
  /*  margin-right: 10px;*/
  /*  position: relative;*/

  /*  .wrap-img {*/
  /*    width: 45px;*/
  /*    height: 45px;*/
  /*    border-radius: 50%;*/

  /*    img {*/
  /*      width: 45px;*/
  /*      height: 45px;*/
  /*      border-radius: 50%;*/
  /*    }*/
  /*  }*/
  /*  .photo {*/
  /*    width: 45px;*/
  /*    height: 45px;*/
  /*    border-radius: 50%;*/
  /*  }*/
  /*}*/

  .btn-edit {
    text-transform: inherit;
    outline: none;
    border-radius: 8px;
    background-color: #00C443;
    margin-right: 10px;

    img {
      height: 16px;
    }

    &:hover {
      background-color: #00ad3b;
    }
  }

  .cancel {
    text-transform: inherit;
    border-radius: 8px;
    background: #F0F6FE;
    margin: 0 auto;
    outline: none;

    img {
      height: 14px;
    }
    &:hover {
      background-color: #E7EFFF;
    }
  }

  .v-btn:not(.v-btn--round).v-size--default {
    height: 36px;
    min-width: 55px;
    // width: 124px;
    padding: 10px;
  }
}

@media screen and (max-width: 650px) {
    .block-money {
        span {
            flex-direction: column;
            width: 64px;
            align-items: flex-start;

            .line {
                display: none;
            }

            p {
                width: 64px;
                font-size: 14px;
                line-height: 20px;
                text-align: left;
            }
        }
    }

    .block-img-game {
        /*margin-right: 10px;*/
        position: relative;

        .wrap-img-game {
            width: 40px;
            height: 40px;
            border-radius: 4px;
            box-shadow: 0px 2px 24px rgba(0, 0, 0, 0.05);

            img {
                width: 40px;
                height: 40px;
                border-radius: 4px;
            }
        }
    }

    .bid-list {

        .v-list-item {

            &__avatar {
                /*min-width: 45px;*/
            }

            &__title {
                font-weight: 400;
                font-size: 13px;
                line-height: 17px;
                text-transform: capitalize;
                color: #002B50;
                max-width: 150px;
                min-width: 150px;
                margin-right: 10px;
            }

            &__subtitle {
                font-size: 11px;
                line-height: 14px;
                max-width: 150px;
                min-width: 150px;

                .block-info-game {
                    font-size: 11px;
                    line-height: 14px;
                }
            }
        }
    }

    .wrap-btn {
        .wrap-delete-btn {
            display: none;
        }
    }
}

@media screen and (max-width: 450px) {
    .block-money {

        .wrap-icon {
            width: 30px;
            img {
                height: 16px;
            }
        }
        span {
            flex-direction: column;
            width: 58px;

            .line {
                display: none;
            }

            p {
                width: 58px;
                font-size: 12px;
                line-height: 18px;
                text-align: left;
            }
        }
    }

    .bid-list {
        .v-list-item {

            &__title {
                max-width: 110px;
                min-width: 110px;
                margin-right: 5px;
            }

            &__subtitle {
                max-width: 110px;
                min-width: 110px;
            }
        }
    }
}

/*@media screen and (max-width: 525px) {*/
/*    .block-money {*/
/*        !*margin-right: 15px;*!*/
/*        span {*/
/*            font-size: 10px;*/
/*        }*/

/*        img {*/
/*            height: 8px;*/
/*        }*/

/*        .v-btn {*/
/*            font-size: 10px;*/
/*            margin-left: 15px;*/
/*            border-radius: 6px;*/
/*        }*/
/*    }*/
/*    .btn-edit {*/
/*        text-transform: inherit;*/
/*        outline: none;*/
/*        border-radius: 6px;*/
/*        background-color: #00C443;*/
/*        margin-right: 10px;*/

/*        img {*/
/*            height: 11px;*/
/*        }*/

/*        &:hover {*/
/*            background-color: #00ad3b;*/
/*        }*/
/*    }*/

/*    .cancel {*/
/*        text-transform: inherit;*/
/*        border-radius: 6px;*/
/*        background: #F0F6FE;*/
/*        margin: 0 auto;*/
/*        outline: none;*/

/*        img {*/
/*            height: 10px;*/
/*        }*/
/*        &:hover {*/
/*            background-color: #E7EFFF;*/
/*        }*/
/*    }*/

/*    .v-btn:not(.v-btn--round).v-size--default {*/
/*        height: 30px;*/
/*        min-width: 40px;*/
/*        // width: 124px;*/
/*        padding: 10px;*/
/*    }*/

/*    .block-img {*/
/*        margin-right: 5px;*/
/*        .wrap-img {*/
/*            width: 38px;*/
/*            height: 38px;*/
/*            border-radius: 50%;*/

/*            img {*/
/*                width: 38px;*/
/*                height: 38px;*/
/*                border-radius: 50%;*/
/*            }*/
/*        }*/
/*    }*/

/*    .bid-list {*/
/*        padding: 5px 10px;*/

/*        .v-list-item {*/

/*            &__avatar {*/
/*                min-width: 45px;*/
/*            }*/

/*            &__title {*/
/*                font-weight: 400;*/
/*                font-size: 10px;*/
/*                line-height: 19px;*/
/*                text-transform: capitalize;*/
/*                color: #002B50;*/
/*                margin-bottom: 0px;*/
/*            }*/

/*            &__subtitle {*/
/*                font-size: 8px;*/
/*                line-height: 16px;*/

/*                img {*/
/*                    height: 6px;*/
/*                    max-width: 10px;*/
/*                }*/
/*            }*/
/*        }*/
/*    }*/
/*}*/

</style>
